// CHG-033: maps one tracker onto ManualViewerV2's lifecycle props. This is the
// only analytics module that reads `import.meta.env`; Vite replaces the value at
// build time, and the Node tests never call `readAnalyticsBaseUrl`.
import type { EmbedAnalyticsTracker, TrackerReadyInfo, TrackerStepPayload } from './tracker.ts';

export function bindViewerLifecycle(tracker: EmbedAnalyticsTracker, signalReady?: () => void) {
  return {
    onReady: (info: TrackerReadyInfo) => {
      signalReady?.();
      tracker.viewerLoad(info);
    },
    onStepAnimationStarted: (payload: TrackerStepPayload) => tracker.stepStarted(payload),
    onStepAnimationFinished: (payload: TrackerStepPayload) => tracker.stepFinished(payload),
  };
}

/** Base URL baked by the canonical `--mode release` build (`.env.release`), or
 *  a process variable in local builds; undefined ⇒ analytics off. */
export function readAnalyticsBaseUrl(): unknown {
  return import.meta.env.VITE_ANALYTICS_BASE_URL;
}
